import { HeroFeaturedEditorial as HeroFeaturedEditorial$1 } from '@cbhq/cdx-components';
import { getComposeEntryProps } from '../globals/composePage.js';
import { mapEntryLink } from '../globals/navlink.js';
import { getEntryProps } from '../utils/getEntryProps.js';
import { jsx } from 'react/jsx-runtime';
const HERO_FEATURED_EDITORIAL_CONTENT_MODEL_ID = 'cdxHeroFeaturedEditorial';
function HeroFeaturedEditorial({
  featuredEditorialPage,
  layout,
  eyebrow
}) {
  if (!featuredEditorialPage) return null;

  // TODO: map to new template fields
  const _getComposeEntryProps = getComposeEntryProps(featuredEditorialPage),
    headline = _getComposeEntryProps.headline,
    excerpt = _getComposeEntryProps.excerpt,
    image = _getComposeEntryProps.image,
    composeSlug = _getComposeEntryProps.composeSlug,
    tags = _getComposeEntryProps.tags,
    readTime = _getComposeEntryProps.readTime,
    publicationDate = _getComposeEntryProps.publicationDate;
  const categoryTag = tags?.find(tag => tag.fields.type !== 'internal');
  const _getEntryProps = getEntryProps(categoryTag),
    label = _getEntryProps.label,
    link = _getEntryProps.link;
  const tagLink = mapEntryLink(link);
  return /*#__PURE__*/jsx(HeroFeaturedEditorial$1, {
    headline: headline || '',
    excerpt: excerpt,
    mediaUrl: image?.fields.file?.url,
    mediaAlt: image?.fields.title,
    bordered: true,
    layout: layout,
    eyebrow: eyebrow,
    url: composeSlug,
    readTime: readTime,
    publicationDate: publicationDate,
    categoryTagLabel: label,
    categoryTagUrl: tagLink.url && `/${tagLink.url}`
  });
}
export { HERO_FEATURED_EDITORIAL_CONTENT_MODEL_ID, HeroFeaturedEditorial };
//# sourceMappingURL=HeroFeaturedEditorial.js.map
